/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import * as styles from './Modal.scss'

interface IProps {
  children: any,
}

const ModalMessage: React.SFC<IProps> = ({ children }) => (
  <div className={styles.modalMessage}>
    {children}
  </div>
)

export default ModalMessage
